import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { DEVICES_REDUCER_KEY } from './constants';
import { getAllUsersSelectors } from '../Users/selectors';

/**
 * Direct selector to the loginPage state domain
 */

const selectDevicesSubStore = state => state[DEVICES_REDUCER_KEY] || initialState;

/**
 * Other specific selectors
 */

export const getAllDevicesListSelector = createSelector(
  selectDevicesSubStore,
  deviceStore => deviceStore.all || initialState.all,
);
export const getOwnedDevicesSelector = createSelector(
  selectDevicesSubStore,
  deviceStore => deviceStore.owned || initialState.owned,
);
export const getSelectedDeviceSelector = createSelector(
  selectDevicesSubStore,
  deviceStore => deviceStore.selected || initialState.selected,
);
export const getMonitoringPopoverIMEISelector = createSelector(
  selectDevicesSubStore,
  device => device.monitoringPopover,
);
export const getOwnedDeviceCallSuccessSelector = createSelector(selectDevicesSubStore, device => device.ownedDevicesCallSuccess);

export const getLocationPopoverIMEISelector = createSelector(selectDevicesSubStore, device => device.locationPopover);

export const getOwnerDetailsForDeviceSelector = createSelector(
  getSelectedDeviceSelector,
  getAllUsersSelectors,
  (device, allUsers) => (allUsers || []).find(user => user.uuid === device.ownerUUID) || {},
);

export const getDeviceRelativesSelector = createSelector(getSelectedDeviceSelector, device => device.relatives || []);

export const getRelativeObjsForDeviceSelector = createSelector(
  getDeviceRelativesSelector,
  getAllUsersSelectors,
  (relatives, allUsers) => {
    const usersMap = {};
    relatives.forEach(uuid => {
      usersMap[uuid] = true;
    });

    return (allUsers || []).filter(user => usersMap[user.uuid]);
  },
);
